import { Breadcrumb } from "@hub/models/ui/breadcrumb";
import React from "react";
import styles from "./breadcrumbs.module.css";

interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs }) => {
  if (breadcrumbs.length < 1) {
    return null;
  }

  const localBreadcrumbs = [];
  let isFullStack = false;

  for (let i = 0; i < breadcrumbs.length; i++) {
    const breadcrumb = breadcrumbs[i];

    if (
      breadcrumb &&
      breadcrumb.path &&
      breadcrumb.path.includes("full-stack")
    ) {
      isFullStack = true;
      localBreadcrumbs.push(breadcrumb);
      break;
    }

    if (breadcrumb) {
      localBreadcrumbs.push(breadcrumb);
    }
  }

  const lastBreadcrumb = localBreadcrumbs.length - 1;

  return (
    <nav className={styles.breadcrumbs}>
      {localBreadcrumbs.map((breadcrumb, index) => {
        return index < lastBreadcrumb ? (
          <div
            className={`${styles.breadcrumb} ${styles.breadcrumb_active}`}
            key={breadcrumb.label}
          >
            <a className={styles.breadcrumb__link} href={`${breadcrumb.path}`}>
              <span className={styles.breadcrumb__label}>
                {breadcrumb.label}
              </span>
            </a>
            <div className={styles.breadcrumb__divider}>/</div>
          </div>
        ) : isFullStack ? (
          <div
            className={`${styles.breadcrumb} ${styles.breadcrumb_active}`}
            key={breadcrumb.label}
          >
            <a className={styles.breadcrumb__link} href={`${breadcrumb.path}`}>
              <span className={styles.breadcrumb__label}>
                {breadcrumb.label}
              </span>
            </a>
          </div>
        ) : (
          <div className={styles.breadcrumb} key={breadcrumb.label}>
            <span className={`${styles.breadcrumb__label}`}>
              {breadcrumb.label}
            </span>
          </div>
        );
      })}
    </nav>
  );
};
